const SKIP_MAINTENANCE_STORAGE_KEY = 'boatpark_skip_maintenance_check';
const BYPASS_TAP_COUNT = 7;

type BypassListener = (enabled: boolean) => void;

let bypassEnabled = readInitialBypassState();
let tapCount = 0;
let tapResetTimer: number | null = null;
const listeners = new Set<BypassListener>();

function readSkipMaintenanceQueryParam(): boolean | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const skipParam = new URLSearchParams(window.location.search).get(
    'skipMaintenance',
  );

  if (skipParam === '1' || skipParam === 'true') {
    return true;
  }

  if (skipParam === '0' || skipParam === 'false') {
    return false;
  }

  return null;
}

function readInitialBypassState(): boolean {
  if (process.env.REACT_APP_SKIP_MAINTENANCE_CHECK === 'true') {
    return true;
  }

  if (typeof window === 'undefined') {
    return false;
  }

  const skipFromQuery = readSkipMaintenanceQueryParam();
  if (skipFromQuery === true) {
    localStorage.setItem(SKIP_MAINTENANCE_STORAGE_KEY, 'true');
    return true;
  }

  if (skipFromQuery === false) {
    localStorage.removeItem(SKIP_MAINTENANCE_STORAGE_KEY);
    return false;
  }

  return localStorage.getItem(SKIP_MAINTENANCE_STORAGE_KEY) === 'true';
}

function persistBypassState(enabled: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (enabled) {
    localStorage.setItem(SKIP_MAINTENANCE_STORAGE_KEY, 'true');
    return;
  }

  localStorage.removeItem(SKIP_MAINTENANCE_STORAGE_KEY);
}

function notifyBypassListeners(): void {
  listeners.forEach((listener) => listener(bypassEnabled));
}

function resetBypassTapCounter(): void {
  tapCount = 0;

  if (tapResetTimer !== null) {
    window.clearTimeout(tapResetTimer);
    tapResetTimer = null;
  }
}

export function subscribeMaintenanceBypass(
  listener: BypassListener,
): () => void {
  listeners.add(listener);
  listener(bypassEnabled);

  return () => {
    listeners.delete(listener);
  };
}

export function isMaintenanceBypassEnabled(): boolean {
  return bypassEnabled;
}

export function enableMaintenanceBypass(): void {
  bypassEnabled = true;
  persistBypassState(true);
  notifyBypassListeners();
}

export function disableMaintenanceBypass(): void {
  bypassEnabled = false;
  persistBypassState(false);
  resetBypassTapCounter();
  notifyBypassListeners();
}

export function registerMaintenanceBypassTap(): boolean {
  tapCount += 1;

  if (tapResetTimer !== null) {
    window.clearTimeout(tapResetTimer);
  }

  tapResetTimer = window.setTimeout(resetBypassTapCounter, 2000);

  if (tapCount >= BYPASS_TAP_COUNT) {
    enableMaintenanceBypass();
    resetBypassTapCounter();
    return true;
  }

  return false;
}
